// extracted by mini-css-extract-plugin
export default {"banner":"VerifyEmailBanner_banner__fLS9U","resend":"VerifyEmailBanner_resend__hmJur","sent":"VerifyEmailBanner_sent__08uW8"};